import DefaultActions from "./DefaultActions";

export default function DefaultExamActions({ defaultItems }) {
	return <DefaultActions defaultItems={defaultItems} />;
}
